import type {FC} from 'react';
import {NoteList} from '../NoteList';
import {useDocumentationBreakpoint} from './useDocumentationBreakpoint';

export const NotesTab: FC = () => {
  const isCompact = useDocumentationBreakpoint() === 'compact';

  return (
    <NoteList>
      <NoteList.LoadError />
      <NoteList.Count />
      <NoteList.Grid compact={isCompact} />
    </NoteList>
  );
};
